module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'mainpage' && templateVars.config ?
				templateVars.config :
				{
	"slidesInteractiveParams": {
		"slide-1": {
			"sliderAnimationSpeed": 1000,
			"sliderAutoplaySpeed": 3000
		},
		"slide-2": {
			"pieRotateNextSpeed": 5000,
			"pieSpinSpeed": 300,
			"pieInnerTextFadeSpeed": 500,
			"pieDetailTextFadeSpeed": 500,
			"pieArrowFadeSpeed": 200
		},
		"slide-3": {
			"sliderAnimationSpeed": 300,
			"sliderAutoplaySpeed": 2000
		}
	},
	"sliderParams": {
		"sliderAnimationSpeed": 500
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/mainpage/config.yaml
// module id = 65
// module chunks = 0